enum InvoiceStatus {
    FullyPaid = 'FullyPaid',
    NotPaid = 'NotPaid',
    PartiallyPaid = 'PartiallyPaid',
    Canceled = 'Canceled',
    Unknown = '',
}

export default InvoiceStatus;
